import { Component, OnInit } from '@angular/core';
import { FormArray, FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from "primeng/api";
import { HosdocService } from '../../hospital-doctors/hosdoc-service/hosdoc.service';
import { HospitalService } from '../../hospital.service';
import { PatientsService } from 'src/app/patient-section/patient-service/patients.service';
import { DoctorsService } from 'src/app/doctor-section/doctor-service/doctors.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-hospitalimages',
  templateUrl: './hospitalimages.component.html',
  styleUrls: ['./hospitalimages.component.css'],
  providers:[MessageService]
})
export class HospitalimagesComponent implements OnInit {
  hospitalImagesArray: FormArray;
  cForm: any;
  filesToUpload: Array<File> = [];
  fd: FormData;
  fileSelected
  hosId
  hosImageTitle: any;
  token:any;

  constructor(private route:Router,private activatedRoute:ActivatedRoute,private messageService:MessageService, private hospitalService:HospitalService,private patientService:PatientsService,private docService:DoctorsService,private authService:AuthService) { }

  ngOnInit() {
    this.hosId=this.activatedRoute.snapshot.queryParams['id'];
    this.authService.authDataSubject.pipe(take(1)).subscribe(res => {
      this.token = res._token;
    });
    this.onInitForm()

  }
  onAddFormImagesArray(){
    this.hospitalImagesArray.push(
      new FormGroup({
        imagetitle: new FormControl(null,Validators.required),
        image: new FormControl(null,Validators.required),
      })
    );
  }

  onRemoveImagesArray(i){
    if(i>0){
this.hospitalImagesArray.removeAt(i)
     this.filesToUpload.splice(i,1)
    }

  }
onInitForm(){
  this.hospitalImagesArray = new FormArray([
    new FormGroup({
      imagetitle: new FormControl(null,Validators.required),
      image: new FormControl(null,Validators.required),
    }),
  ]);
  this.cForm = new FormGroup({
   
    hosVideo: this.hospitalImagesArray,

  });
}
 

get controls() {
  return (this.cForm.get("hosVideo") as FormArray).controls;
}

onAddFormArray() {
 
}
onRemovesyllabusArray(i) {
}
onChangeProfile(event){
  this.fileSelected = <File>event.target.files[0];
//this.fd.append('profileimage',fileSelected,fileSelected.name)
this.filesToUpload.push(this.fileSelected)

}
onSubmit(){
   const hosImageTitle = this.cForm.value["hosVideo"]
  
  console.log( hosImageTitle)
if(hosImageTitle.length===this.filesToUpload.length){
  this.hospitalService.addHospitalImages(hosImageTitle,this.filesToUpload,this.hosId,this.token).subscribe(res=>{
  })       
}else{
  alert('please fill all the required field')
}
}
}
